import * as React from 'react'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import HtmlHead from '../components/HtmlHead'
import type { AppStateType } from '../reducers/appstate'
import { withRouter } from 'next/router'
import { GlobalStyle, colors } from '@components/shared'
import BenefitsLandingPage from '@components/BenefitsLandingPage'
import type { PropsType } from '@components/BenefitsLandingPage'
import { openSubscribe } from '../actions/navigationActions'
import { dismissIntercom } from '@services/intercom'

const chapterImages = [
  'https://api.dipseastories.com/images/1000-KillianPillowtalk13.png?w=1080',
  'https://api.dipseastories.com/images/1000-686_FamiliarFaceI_ArielSinha_Compressed.png?w=1080',
  'https://api.dipseastories.com/images/1000-634_TeamPlayers2_Midjourney.png?w=1080',
  'https://api.dipseastories.com/images/1000-TheLocal12.png?type=media?w=1080',
  'https://api.dipseastories.com/images/1000-RonanPillowtalk2.png?w=1080'
]
function LandingPage (_props: PropsType): React.ReactNode {
  React.useEffect((): void => {
    dismissIntercom()
  }, [])
  const copy = {
    header: 'Feeling Lucky?',
    subHeader: 'This St. Patrick’s Day, find your new fictional Irish crush and enjoy 1,000+ spicy audio stories ☘️\n',
    subBody: 'Try Dipsea for 7 days free. Cancel anytime during your trial, and you won’t be charged.',
    benefitsArr: [
      'The perfect way to treat yourself',
      'Bite-sized romance gets you right to the good part',
      'Made by women for the female gaze'
    ],
    ctaText: 'REDEEM OFFER',
    trialLanguage: 'GET 30% OFF + 7 DAYS FREE'
  }
  return (
    <>
      <GlobalStyle backgroundColor={colors.white} />
      <HtmlHead
        title={`Dipsea | Get lost in a steamy fantasy world`}
        description={
          'Get access to the entire Dipsea library to explore 1,000+ sexy audio stories, soothing sleep scenes, steamy POV role-plays, and more. '
        }
      />
      <BenefitsLandingPage color={'seaGreen'} inlineSubscribe={true} copyText={copy} chapterImages={chapterImages}/>
    </>
  )
}

const mapStateToProps = (_state: AppStateType): any => {
  return {
  }
}

const mapDispatchToProps = (dispatch: Dispatch<any>): any => {
  return {
    openSubscribe: (): void => dispatch(openSubscribe())
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LandingPage) as any) as any
